<div class="vcu-card" [class.card-inactive]="!isActive">
  <!-- Imagem do produto (estilo card-vcu original) - clicável para detalhes -->
  <div class="card-image-bg" (click)="goVcuDetail()" role="button" tabindex="0" (keydown.enter)="goVcuDetail()">
    <div class="card-image" [ngStyle]="{'background-image': formatImage() }"></div>
  </div>

  <!-- Info -->
  <div class="card-info">
    <!-- Header: status + ações -->
    <div class="card-header">
      <span class="card-status">
        <i class="pi pi-circle-fill" [ngClass]="statusClass"></i>
        {{ statusDescription | transloco }}
      </span>
      <div class="card-actions">
        <p-button
          class="action-btn"
          icon="pi pi-pencil"
          [rounded]="false"
          [text]="true"
          (onClick)="startEditNickname()"
          [pTooltip]="'vcuPair.card.editNickname' | transloco"
          tooltipPosition="top"
        ></p-button>
        <p-button
          class="action-btn action-btn-danger"
          icon="pi pi-link"
          [rounded]="false"
          [text]="true"
          (onClick)="onUnpair()"
          [pTooltip]="'vcuPair.card.unpair' | transloco"
          tooltipPosition="top"
        ></p-button>
      </div>
    </div>

    <!-- Nickname / Serial -->
    <div class="card-name-row" *ngIf="!isEditingNickname">
      <h3 class="card-title">{{ displayName }}</h3>
    </div>

    <!-- Edição inline -->
    <div class="card-name-edit" *ngIf="isEditingNickname">
      <input
        type="text"
        class="nickname-input"
        [(ngModel)]="editNicknameValue"
        [placeholder]="'vcuPair.card.nicknamePlaceholder' | transloco"
        (keydown)="onNicknameKeyDown($event)"
        maxlength="50"
        autofocus
      />
      <div class="edit-actions">
        <p-button icon="pi pi-check" severity="success" [text]="true" (onClick)="saveNickname()"></p-button>
        <p-button icon="pi pi-times" severity="danger" [text]="true" (onClick)="cancelEditNickname()"></p-button>
      </div>
    </div>

    <!-- Serial number -->
    <div class="card-serial">
      <span class="serial-label">S/N:</span>
      <span class="serial-value">{{ displaySerial }}</span>
    </div>

    <!-- Grid de informações -->
    <div class="card-details-grid">
      <div class="detail-item">
        <span class="detail-label">{{ 'vcuPair.card.model' | transloco }}</span>
        <span class="detail-value">{{ modelDisplay }}</span>
      </div>
      <div class="detail-item">
        <span class="detail-label">{{ 'vcuPair.card.swVersion' | transloco }}</span>
        <span class="detail-value">{{ vcu.version || '-' }}</span>
      </div>
      <div class="detail-item">
        <span class="detail-label">{{ 'vcuPair.card.hwVersion' | transloco }}</span>
        <span class="detail-value">{{ vcu.hwVersion || '-' }}</span>
      </div>
      <div class="detail-item">
        <span class="detail-label">{{ 'vcuPair.card.lastAccess' | transloco }}</span>
        <span class="detail-value">{{ lastAccessRelative }}</span>
      </div>
    </div>

    <!-- Footer: data + botão detalhes -->
    <div class="card-footer">
      <div class="footer-info">
        <i class="pi pi-calendar"></i>
        <span>{{ 'vcuPair.card.createdAt' | transloco }}: {{ createdAtFormatted }}</span>
      </div>
      <p-button
        class="details-btn"
        (onClick)="goVcuDetail()"
        [pTooltip]="'vcuPair.card.details' | transloco"
        tooltipPosition="top"
      >
        <i class="pi pi-chevron-right"></i>
      </p-button>
    </div>
  </div>
</div>
<div class="polygon"></div>
